import { render } from "./page6.vue?vue&type=template&id=4d6d2834&scoped=true"
import script from "./page6.vue?vue&type=script&lang=js"
export * from "./page6.vue?vue&type=script&lang=js"

import "./page6.vue?vue&type=style&index=0&id=4d6d2834&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d6d2834"]])

export default __exports__